module.exports = __webpack_public_path__ + "static/media/astro-popin.107f08cc.gif";